var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-text--sm w-100"
  }, [_c('v-img', {
    staticClass: "w-100 mb-12 mb-lg-18",
    attrs: {
      "src": _vm.src
    }
  }), _vm.sc1 ? _c('p', {
    staticClass: "color-grey-7",
    attrs: {
      "data-aos": "fade-down"
    }
  }, [_vm._v(" " + _vm._s(_vm.sc1) + " ")]) : _vm._e(), _vm.sc2 ? _c('p', {
    staticClass: "font-weight-bold",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" " + _vm._s(_vm.sc2) + " ")]) : _vm._e(), _vm._t("default")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }